import { App_Url_New } from "@/shared/common/static";
import { whiteLabelContent } from "./content";

export const whiteLabelOcContent = {
  ...whiteLabelContent,
  app: {
    ...whiteLabelContent.app,
    title: "NexInsure - B2C",
  },
  contact: {
    ...whiteLabelContent.contact,
    chatbotName: "Layla",
  },
  homepage: {
    ...whiteLabelContent.homepage,
    hero: {
      ...whiteLabelContent.homepage.hero,
      eyebrow: "Protect your car, home, health, and every journey with confidence.",
      titleLines: ["Protect. Insure.", "Relax."],
      featuredProductPath: App_Url_New.D2CPageUrl.insurance,
    },
    stats: {
      dealsTitle: "Complete Protection",
      dealsSubtitle: "Motor • Health • Travel • Home",
      policyholdersCount: "50K+",
      policyholdersLabel: "Policies protected",
    },
    whyChooseUs: {
      ...whiteLabelContent.homepage.whyChooseUs,
      heading: "Why choose NexInsure?",
      features: [
        {
          title: "One Trusted Insurer",
          description: "Reliable protection for Motor, Health, Travel, and Home insurance.",
        },
        {
          title: "Instant Digital Quotes",
          description: "Get quick quotes and purchase your policy in minutes.",
        },
        {
          title: "Comprehensive Protection",
          description: "Secure every aspect of your lifestyle with one insurance partner.",
        },
        {
          title: "Fast Claims Support",
          description: "Dedicated claims assistance whenever you need it.",
        },
      ],
    },
    offers: {
      heading: "Exclusive NexInsure offers",
      items: [
        {
          title: "Motor Insurance Benefits",
          description: "Comprehensive protection for your car with flexible coverage options.",
          terms: "* T&C apply",
        },
        {
          title: "Health & Home Protection",
          description: "Safeguard your family’s health and your home with trusted coverage.",
          terms: "* T&C apply",
        },
        {
          title: "Travel with Confidence",
          description: "Enjoy worldwide travel protection with reliable emergency assistance.",
          terms: "* T&C apply",
        },
      ],
    },
    products: {
      ...whiteLabelContent.homepage.products,
      eyebrowPrefix: "Protect. Insure.",
      eyebrowHighlight: "Relax.",
      heading: "Non-life insurance for every need",
    },
    mascot: {
      ...whiteLabelContent.homepage.mascot,
      description:
        "Your trusted guide for simple and hassle-free Motor, Health, Travel, and Home insurance.",
      imageAlt: "NexInsure Layla",
      pillars: [
        {
          title: "Insure",
          description: "Find the right cover for your car, home, health, or travel.",
        },
        {
          title: "Claim",
          description: "Get fast and reliable support throughout your claims journey.",
        },
        {
          title: "Manage",
          description: "Keep all your insurance policies secure and accessible in one place.",
        },
      ],
    },
    lifeContent: {
      hero: {
        eyebrow: "Protect your family and grow your savings with the right life plan.",
        titleLines: ["Secure. Grow.", "Live."],
        featuredProductPath: App_Url_New.D2CPageUrl.insurance.lifeGetQuote,
      },
      whyChooseUs: {
        heading: "Why choose NexInsure for Life Insurance?",
        features: [
          {
            title: "Trusted NexInsure Protection",
            description: "Reliable life coverage from NexInsure with long-term financial security.",
          },
          {
            title: "Instant Digital Journey",
            description: "Buy your life policy quickly with a seamless online experience.",
          },
          {
            title: "Family Financial Security",
            description: "Protect your loved ones with comprehensive life insurance benefits.",
          },
          {
            title: "Dedicated Claims Support",
            description: "Expert assistance throughout your policy and claims journey.",
          },
        ],
      },
      offers: {
        heading: "Tap into limited-time life insurance offers",
      },
      products: {
        eyebrowPrefix: "Secure. Grow.",
        eyebrowHighlight: "Live.",
        heading: "Life and investment products in your hands",
      },
      mascot: {
        description: "Your trusted guide for simple and hassle-free life insurance solutions.",
      },
    },
  },
} as const;
